let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fEKYg")).then(() => parcelRequire('6h7q7'));